// in src/authClient.js
import { AUTH_LOGIN, AUTH_LOGOUT, AUTH_ERROR, AUTH_CHECK } from 'admin-on-rest';
import { AUTH_ENDPOINT } from './endpoints'
export const AUTH_REGISTER = 'AUTH_REGISTER';
export const AUTH_FORGOTPASS = 'AUTH_FORGOTPASS';

export default (type, params) => {
    if (type === AUTH_LOGIN) {
        const { username, password } = params;
        const request = new Request(AUTH_ENDPOINT+'login', {
            method: 'POST',
            body: JSON.stringify({ username, password }),
            headers: new Headers({ 'Content-Type': 'application/json' }),
        })
        return fetch(request)
            .then(response => {
                if (response.status < 200 || response.status >= 300) {
                    throw new Error('cloudhints.login_error');
                }
                return response.json();
            })
			.then(function(data) {
				// `data` is the parsed version of the JSON returned from the above endpoint.
				 localStorage.setItem('token', data.auth_token);
			  });
           
    }	
	
	if (type === AUTH_CHECK) {
        //check token
		if(!localStorage.getItem('token')) return Promise.reject();
		
		//check auth
		const token = localStorage.getItem('token');		
		const request = new Request(AUTH_ENDPOINT+'checkauth', {
            method: 'GET',
            headers: new Headers( {'Authorization': `Bearer ${token}` }),
        })
        return fetch(request)
            .then(response => {
                if (response.status == 401 || response.status == 403) {
                    localStorage.removeItem('token');
					return Promise.reject();
                }
                return Promise.resolve();
            })
    }
	
	if (type === AUTH_LOGOUT) {
        localStorage.removeItem('token');
        return Promise.resolve();
    }
	
	if (type === AUTH_ERROR) {
        const status  = params.status;
        if (status === 401 || status === 403) {
            localStorage.removeItem('token');
            return Promise.reject();
        }
        return Promise.resolve();
    }
	
    return Promise.resolve();
}


// WEBPACK FOOTER //
// ./src/authClient.js